import type { ComponentPropsWithoutRef } from "react";

/**
 * 日時表示コンポーネントのProps
 */
type DateTimeDisplayProps = {
  /** UTC日時を表すISO文字列 */
  value: string;
} & Omit<ComponentPropsWithoutRef<"time">, "dateTime" | "children">;

/**
 * 管理画面で日時を表示する
 *
 * @param props - 日時表示の設定
 * @param props.value - UTC日時を表すISO文字列
 * @returns JSTへ変換した日時を表示するtime要素
 */
export const DateTimeDisplay = ({ value, ...props }: DateTimeDisplayProps) => {
  const date = new Date(value);
  const formattedValue = Number.isNaN(date.getTime())
    ? "日時不明"
    : new Intl.DateTimeFormat("ja-JP", {
        dateStyle: "medium",
        timeStyle: "short",
        timeZone: "Asia/Tokyo",
      }).format(date);

  return (
    <time dateTime={value} {...props}>
      {formattedValue}
    </time>
  );
};
